import { MetricType } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/metrics_pb';
import { TFunction } from 'i18next';
import {
  getOutdatedReadingLabel,
  isMetricReadingOutdated,
} from '~/shared/models/metrics/metrics-utils';

export const KPI_V2_DRAINED_TOTAL = 'KPI_V2_DRAINED_TOTAL' as const;
export type SyntheticMetricType = typeof KPI_V2_DRAINED_TOTAL;

export class KpiModel {
  constructor(
    readonly type: MetricType | SyntheticMetricType,
    readonly value: number | undefined,
    readonly date?: Date,
  ) {}

  getLatestTimestampLabel(t: TFunction) {
    if (!this.date) {
      return null;
    }

    if (this.type !== MetricType.KPI_V2_WATER_STORED_L) {
      return null;
    }

    if (!isMetricReadingOutdated(this.date)) {
      return null;
    }

    return getOutdatedReadingLabel(t, this.date);
  }

  getLabel(t: TFunction) {
    switch (this.type) {
      case MetricType.KPI_V2_RAIN_TOTAL_L:
        return t('dashboard.kpi.rainTotalLabel');
      case MetricType.KPI_V2_PLANT_USAGE_L:
        return t('dashboard.kpi.plantUsageLabel');
      case MetricType.KPI_V2_WATER_STORED_L:
        return t('dashboard.kpi.waterStoredLabel');
      case MetricType.KPI_V2_SOIL_LOSS_L:
        return t('dashboard.kpi.soilLossLabel');
      case MetricType.KPI_V2_OVERFLOW_L:
        return t('dashboard.kpi.overflowLabel');
      case MetricType.KPI_V2_TAP_USAGE_L:
        return t('dashboard.kpi.tapUsageLabel');
      case MetricType.KPI_V2_DRAINED_DELAYED_L:
        return t('dashboard.kpi.drainedDelayedLabel');
      case MetricType.KPI_V2_DRAINED_DIRECT_L:
        return t('dashboard.kpi.drainedDirectLabel');
      case KPI_V2_DRAINED_TOTAL:
        return t('dashboard.kpi.drainedTotalLabel');

      default:
        throw new Error(`Unknown KPI type: ${this.type}`);
    }
  }

  getDescription(t: TFunction) {
    switch (this.type) {
      case MetricType.KPI_V2_RAIN_TOTAL_L:
        return t('dashboard.kpi.rainTotalDescription');
      case MetricType.KPI_V2_PLANT_USAGE_L:
        return t('dashboard.kpi.plantUsageDescription');
      case MetricType.KPI_V2_WATER_STORED_L:
        return t('dashboard.kpi.waterStoredDescription');
      case MetricType.KPI_V2_SOIL_LOSS_L:
        return t('dashboard.kpi.soilLossDescription');
      case MetricType.KPI_V2_OVERFLOW_L:
        return t('dashboard.kpi.overflowDescription');
      case MetricType.KPI_V2_TAP_USAGE_L:
        return t('dashboard.kpi.tapUsageDescription');
      case MetricType.KPI_V2_DRAINED_DELAYED_L:
        return t('dashboard.kpi.drainedDelayedDescription');
      case MetricType.KPI_V2_DRAINED_DIRECT_L:
        return t('dashboard.kpi.drainedDirectDescription');
      case KPI_V2_DRAINED_TOTAL:
        return t('dashboard.kpi.drainedTotalDescription');

      default:
        throw new Error(`Unknown KPI type: ${this.type}`);
    }
  }
}
